import {route} from "preact-router";
import {filterService} from "./filter-service";
import {Gender} from "../models/product";
import {config} from "../config";

export class NavigationService {

   public showDetailView(productId:string, variantId:string) {
     const search = filterService.getSearchParams();
     route(config.url(`/detail/${productId}/${variantId}${search}`), false);
   }

   public showCollectionView(collectionId) {
    route(config.url(`/collections/${collectionId}`), false);
   }

   public getDetailViewLink(productId: string, variantId: string) {
     const search = filterService.getSearchParams();
     return config.url(`/detail/${productId}/${variantId}${search}`);
   }

  public closeDetailView() {
    const search = filterService.getSearchParams();
    route(config.url(`/${search}`), false);
  }

  public goToBrand(gender: Gender, brand: string) {
   route(config.url(`/?gender=${gender}&brand=${brand}`), false);
  }
}

export const navigationService = new NavigationService();
